import { useQuery } from "@apollo/client";
import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { ReactElement } from "react";

import { GetDataDictionaryQuery } from "~frontend/__generated__/graphql";
import ErrorCard from "~frontend/components/ErrorCard";
import Loading from "~frontend/components/Loading";
import PageContainer from "~frontend/components/PageContainer";
import { GET_DATA_DICTIONARY } from "~frontend/graphql/tenantExportConfigs";
import { useBreadcrumbs } from "~frontend/providers/BreadcrumbsProvider";

export default function DataDictionary(): ReactElement {
  useBreadcrumbs([
    {
      label: "Data Exports",
      path: "/organization/exports",
    },
    {
      label: "Data Dictionary",
      path: "/organization/exports/dictionary",
    },
  ]);

  const { loading, error, data } =
    useQuery<GetDataDictionaryQuery>(GET_DATA_DICTIONARY);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorCard errors={[error]} />;
  }

  return (
    <PageContainer>
      <h1>Data Dictionary</h1>
      {data!.tenantExportDataDictionary.map(table => (
        <Box key={table.tableName} sx={{ marginBottom: 8 }}>
          <h2>
            <span style={{ fontFamily: "monospace" }}>{table.tableName}</span>
            {table.deprecated && (
              <Chip
                sx={{ marginLeft: 1 }}
                label="Deprecated"
                color="secondary"
              />
            )}
          </h2>
          <p>{table.description}</p>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: "300px" }}>Column</TableCell>
                <TableCell sx={{ width: "125px" }}>Type</TableCell>
                <TableCell sx={{ width: "50px" }}>Nullable</TableCell>
                <TableCell>Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {table.columns.map(column => (
                <TableRow key={column.columnName}>
                  <TableCell sx={{ fontFamily: "monospace" }}>
                    {column.columnName}
                  </TableCell>
                  <TableCell>{column.dataType}</TableCell>
                  <TableCell>{column.nullable ? "Yes" : "No"}</TableCell>
                  <TableCell>
                    {column.deprecated && (
                      <Chip
                        sx={{ marginRight: 1 }}
                        label="Deprecated"
                        color="secondary"
                        size="small"
                      />
                    )}
                    {column.description}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      ))}
    </PageContainer>
  );
}
